import {EventComponent} from './event.component';

export const EventRoutes = [
  {
    path: 'event/:relatedTo/:relatedToId',
    component: EventComponent,
  },
];
